module.exports = __webpack_public_path__ + "static/desktop_text-54637581bd2695435c6c2f88c8c538ed.jpg";